// ============================================================
// CarePeopleRoleMappingsSection.jsx  (2b-13 Gate 5b; refactored onto the shared
// ModuleRoleMappingsSection 2026-07-13)
//
// Thin instantiation of the shared component. CarePeople is the DIVERGENT
// section — it carries the optional "Scope tier" control + TIER table column
// via the shared component's `extra` slot (HR/Supervisor; Supervisor caps at
// tier 1, server-enforced; the tier-2 option is disabled + clamped here for UX).
// Behaviour is preserved exactly (labels, body shape, confirm copy).
// ============================================================

import React from 'react';
import Field from '../components/Field';
import ModuleRoleMappingsSection from './ModuleRoleMappingsSection';
import {
  listCarePeopleRoleMappings,
  createCarePeopleRoleMapping,
  deleteCarePeopleRoleMapping,
} from '../api/federation';

const ROLE_LABEL = { hr: 'HR', supervisor: 'Supervisor', hr_manager: 'HR Manager' };

// The Scope-tier extra field (the one control CareCharge/CarePlan don't have).
const tierExtra = {
  initialForm: { roleScopeTier: 0 },
  // Supervisor caps at tier 1 (A1 §3) — clamp a stray tier-2 selection down.
  normalize: (form) => (
    form.role === 'supervisor' && Number(form.roleScopeTier) === 2
      ? { ...form, roleScopeTier: 1 }
      : form
  ),
  renderFields: (form, setField) => (
    <Field label="Scope tier">
      <select value={form.roleScopeTier} onChange={(e) => setField('roleScopeTier', Number(e.target.value))} aria-label="Scope tier">
        <option value={0}>Tier 0 — carer records only</option>
        <option value={1}>Tier 1 — carer + supervisor records</option>
        <option value={2} disabled={form.role === 'supervisor'}>Tier 2 — carer + supervisor + manager records{form.role === 'supervisor' ? ' (HR only)' : ''}</option>
      </select>
    </Field>
  ),
  buildBody: (form) => ({ roleScopeTier: Number(form.roleScopeTier) }),
  columns: [{ key: 'tier', label: 'Tier', render: (r) => `Tier ${r.roleScopeTier}` }],
};

export default function CarePeopleRoleMappingsSection({ clientId }) {
  return (
    <ModuleRoleMappingsSection
      clientId={clientId}
      testId="carepeople-role-mappings"
      title="CarePeople role mappings"
      descriptor="Map an AD group to a CarePeople module role (HR / Supervisor / HR Manager) + tier. Members are auto-granted on sign-in and the hourly reconcile."
      roleField="carePeopleRole"
      roleOptions={[{ value: 'hr', label: 'HR' }, { value: 'supervisor', label: 'Supervisor' }, { value: 'hr_manager', label: 'HR Manager' }]}
      emptyMessage="No CarePeople role mappings configured yet."
      confirmTitle="Remove CarePeople role mapping?"
      confirmMessage={(t) => `Members of "${t.groupDisplayName || t.groupObjectId}" will lose this ${ROLE_LABEL[t.carePeopleRole] || t.carePeopleRole} mapping at the next reconcile. Existing grants are not removed immediately.`}
      toastCreated="CarePeople role mapping created."
      toastRemoved="CarePeople role mapping removed."
      api={{ list: listCarePeopleRoleMappings, create: createCarePeopleRoleMapping, remove: deleteCarePeopleRoleMapping }}
      extra={tierExtra}
    />
  );
}
